export enum IPhase {
  UNUSED = 'unused',
  UNKNOWN = 'unknown',
  NONE = 'none',
}

export interface IPhases {
  id: number;
  phase: IPhase;
}
